import { render, staticRenderFns } from "./StartElement.vue?vue&type=template&id=67db2d6c&"
import script from "./StartElement.vue?vue&type=script&lang=js&"
export * from "./StartElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports